// Тело FAQ-статьи + кнопки «Помогло / Не помогло».
import React, { useEffect, useState } from "react";
import { getFaq, faqHelpful } from "../../api/tickets";

export default function FaqArticle({ id, onBack, onCreateTicket }) {
  const [a, setA] = useState(null);
  const [err, setErr] = useState(null);
  const [voted, setVoted] = useState(false);

  useEffect(() => {
    let cancelled = false;
    getFaq(id)
      .then((d) => { if (!cancelled) setA(d); })
      .catch((e) => { if (!cancelled) setErr(e.message); });
    return () => { cancelled = true; };
  }, [id]);

  const vote = async (value) => {
    try {
      const next = await faqHelpful(id, value);
      setA((prev) => prev && { ...prev, ...next });
      setVoted(true);
    } catch {
      // молча — не критично
      setVoted(true);
    }
  };

  if (err) return <div className="sup-msg-err">Ошибка: {err}</div>;
  if (!a) return <div className="sup-msg-info">Загрузка…</div>;

  return (
    <div>
      <button type="button" className="sup-btn-ghost" onClick={onBack}
              style={{ marginBottom: 12 }}>
        ‹ К списку FAQ
      </button>
      <h2 style={{ fontSize: 18, fontWeight: 800, color: "#1e293b",
                   margin: "0 0 12px" }}>{a.title}</h2>
      <div style={{ fontSize: 14, color: "#334155", lineHeight: 1.6,
                    whiteSpace: "pre-wrap" }}>
        {a.body}
      </div>

      <div style={{ display: "flex", gap: 8, marginTop: 18, alignItems: "center" }}>
        {voted ? (
          <span className="sup-msg-ok">Спасибо за оценку</span>
        ) : (
          <>
            <button type="button" className="sup-btn-ghost"
                    onClick={() => vote(true)}>
              Помогло ({a.helpful_yes || 0})
            </button>
            <button type="button" className="sup-btn-ghost"
                    onClick={() => vote(false)}>
              Не помогло ({a.helpful_no || 0})
            </button>
          </>
        )}
      </div>

      {onCreateTicket && (
        <div style={{ marginTop: 16 }}>
          <button type="button" className="sup-btn-primary"
                  onClick={onCreateTicket}>
            Не нашёл ответ — написать в поддержку
          </button>
        </div>
      )}
    </div>
  );
}
